module.exports = __webpack_public_path__ + "static/media/5.e4ff3553.JPG";